<template>
  <div id="header-search" :class="{'mobile-search-mode': showMobileSearch, 'mobile-search-width': setMobileSearchWidth}">
    <i class="clear-mobile-view-icon fa-solid fa-xmark fs-3 p-3" @click="closeMobileSearch"></i>

    <div id="autocomplete" class="rounded-pill position-relative"
         :class="{focused: isActive}">
      <form :action="formAction" @submit.prevent="submitSelected" id="header-search-form" ref="headersearch"
            role="form">
        <input name="search" type="hidden" value="header">
        <input aria-label="Search Card Kingdom" autocapitalize="off" autocomplete="off" autocorrect="off"
               id="header-search-input"
               class="headerSearchInput form-control ui-autocomplete-input d-inline-block"
               name="filter[name]"
               :placeholder="searchInputPlaceholder"
               ref="headerSearchInput"
               type="text"
               value=""
               v-focus
               v-model="searchValue"
               value="searchValue"
               @blur="setInactiveCheck"
               @focus="initAutoCompleteData"
               @keyup="processInput"
               @click="setActive"
        >
        <i class="input-clear fa-regular fa-xmark fs-3 position-absolute" @click.stop="clearInput"
           v-if="searchValue.length > 0"></i>


        <button class="input-icon" @click="searchIconClick">
          <img src="/local/images/fontawesome/magnifying-glass-solid.svg" class="fs-2 align-self-center" alt="Search Icon" v-if="!isActive">
          <img src="/local/images/fontawesome/magnifying-glass-solid-cknavy.svg" class="fs-2 align-self-center"
               alt="Search Icon" v-else>
        </button>

        <search-result-list
            :search-results="searchResults"
            :search-history="searchHistory"
            v-if="searchResults.length > 0 || isActive"
            :selectedItem="selectedItem"
            :searchValue=searchValue
            v-on:searchOnThis="searchOnThis"
            v-on:clearSearchHistory="clearSearchHistory"
            @active-title="setActiveTitle"/>
      </form>
    </div>
  </div>

</template>

<script>
import Cookies from '../../utils/cookies.js';
import OnAnyClick from '../../utils/OnAnyClick.js';
import SearchResultList from './SearchResultList.vue';

export default {
  props: {
    cartmode: {
      type: String,
      default: "cartmode"
    },
    location_name: {
      type: String,
      default: "Card Kingdom"
    },
  },
  components: {
    SearchResultList,
    Cookies
  },
  data() {
    return {
      activeItem: null,
      isActive: false,
      isSubmitting: false,
      showMobileSearch: false,
      searchValue: '',
      searchResults: [],
      searchHistory: [],
      selectedItem: null,
      setMobileSearchWidth: false,
      userInput: '',
    };
  },
  computed: {
    formAction() {
      if (this.cartmode.indexOf('purchasing') == -1) {
        return '/catalog/search';
      }
      return '/purchasing/mtg_singles';
    },
    searchInputPlaceholder() {
      if (this.cartmode.indexOf('purchasing') == -1) {
        return 'Search ' + this.location_name;
      }
      return 'Search Card Kingdom Buy List';
    }
  },
  methods: {
    cleanInput(input) {
      const cleanIt = document.createElement('div');
      cleanIt.innerHTML = input;
      return cleanIt.textContent;
    },
    clearInput() {
      this.isActive = false;
      this.activeItem = null;
      this.searchResults = [];
      this.searchValue = '';
      this.selectedItem = null;
      this.UserInput = '';
      this.$refs.headerSearchInput.focus();

    },
    clearSearchHistory() {
      this.isActive = false;
      this.activeItem = null;
      this.searchHistory = [];
      this.selectedItem = null;
      Cookies.set('searchHistory', '', 1); //cookieName, cookieValue, daysToExpire
      this.$refs.headerSearchInput.focus();

    },
    closeMobileSearch() {

      this.setMobileSearchWidth = false;
      $('#header').removeClass('mobile-search-mode');
      setTimeout( () => {
        this.showMobileSearch = false; //delay removing mobile display until after width animation completes
      },300);

    },

    getSearchHistory() {
      let searchHistory = Cookies.get('searchHistory');
      this.searchHistory = typeof (searchHistory) == 'string' ? JSON.parse(searchHistory) : [];
      //remove null elements
      this.searchHistory = this.searchHistory.filter(function (el) {
        return el != null;
      });

    },
    initAutoCompleteData() {
      this.getSearchHistory();
      if (this.$store) {
        this.$store.dispatch('initAutoComplete', {ck: ck || {}});
      }
      if (this.searchValue.length > 2) {
        this.processSearch(this.searchValue);
      }
    },
    openMobileSearch() {
      this.showMobileSearch = true;
      this.setMobileSearchWidth = true;
      $('#header').addClass('mobile-search-mode'); //required for external element animation
      this.$refs.headerSearchInput.focus();
    },
    processInput(evt) {
      //tracking for keyboard navigation and direct input
      if (evt.key === "Escape") {
        this.isActive = false;
        this.searchResults = [];
        this.searchValue = '';
        this.selectedItem = null;
      }
      if (this.searchValue.length > 0) {
        this.isActive = true;
      }
      if (this.isActive) {
        if (evt.key === "ArrowDown" || evt.key == "Tab") {
          if (this.searchResults.length > 0 || this.searchHistory.length > 0) {
            if (this.selectedItem === null) {
              this.selectedItem = 0;
              this.userInput = this.searchValue;
            } else {
              if ((this.searchResults.length > this.selectedItem + 1) ||
                  (this.searchResults.length < 1 && this.searchHistory.length > this.selectedItem + 1)) {
                this.selectedItem++;
              }
            }
          }
        } else if (evt.key === "ArrowUp") {
          this.selectedItem--;
          if (this.selectedItem < 0) {
            this.selectedItem = null;
            this.searchValue = this.userInput;
          }
        } else {
          if(!this.isSubmitting) {
            this.processSearch(this.searchValue);
          }

        }
      }
    },
    processSearch(val) {
      this.setActive();
      let checkForMatch = (item) => {
        val = val.replace(/[\u2018\u2019]/g, '\'');
        let regex = new RegExp('\\b' + val, 'ig');
        return item.match(regex);
      };
      if (val.length > 2) {
        this.searchResults = (this.$store.state.autoCompleteResults).filter(checkForMatch);
      } else {
        this.searchResults = [];
      }
    },
    searchIconClick() {
      if (this.showMobileSearch || window.outerWidth > 775) {
        this.searchOnClick();
      } else {
        this.openMobileSearch();
      }
    },
    searchOnClick() {
      if (this.searchValue.length > 0) {
        this.setInactive();
        this.$refs.headersearch.submit();
      }

    },
    searchOnThis(item) {
      this.activeItem = item;
      this.searchValue = this.cleanInput(item.title);
      this.submitSelected();
    },
    setActive() {
      this.isActive = true;
    },
    setActiveTitle(item) { //from keyboard navigation
      this.activeItem = item;
      setTimeout(() => {
        if (typeof this.activeItem == 'object' && typeof this.activeItem.title == 'string') {
          this.activeItem.$el.scrollIntoView({
            behavior: "smooth",
            block: "end"
          });
        }
      }, 100);
    },
    setInactive() {
      this.isActive = false;
      this.searchResults = [];
    },
    setInactiveCheck(evt) {
      if (!(evt.relatedTarget && $(evt.relatedTarget).parents('#header-search-input'))) {
        this.setInactive();
      }
    },
    setSearchHistory() {
      let searchParams = this.searchHistory;
      //remove empty and repeat search results from list
      searchParams = this.searchHistory.filter((item) => {
        return typeof item == 'string' && item.length > 0 && item.toLowerCase() !== this.searchValue.toLowerCase();
      });
      searchParams.push(this.searchValue);
      if (searchParams.length > 10) {
        searchParams.shift();
      }
      Cookies.set('searchHistory', JSON.stringify(searchParams), 90); //cookieName, cookieValue, daysToExpire

    },
    submitSelected() {
      if (this.activeItem) {
        this.searchValue = this.activeItem.$el.textContent;
      } else {
        this.searchValue = this.cleanInput(this.searchValue);
      }

      if (this.searchValue.length > 0) {
        this.isSubmitting = true;
        this.setSearchHistory();
        this.setInactive();
        setTimeout(() => {
          this.searchHistory = [];
          this.$refs.headersearch.submit();
        }, 300);

      }

    },
    toggleMobileBasicSearch() {
      this.searchResults = [];
    },

  },
  mounted() {
    OnAnyClick.closeIfNoMatch(this, (payload) => {
      this.searchResults = [];
      this.searchValue = this.userInput;
    });
  },
  directives: {
    focus: {
      inserted: function (el) {
        setTimeout(function () {
          if ($(el).is(':visible')) {
            $(el).focus();
          }
        }, 0);
      },
    }
  }
};
</script>

<style lang="scss">
@import '../../../sass/_variables.scss';

/* all css transitions in one place*/
#autocomplete { transition: width .5s; }
#autocomplete .input-icon img { transition: height .5s, width .5s; }
#header-search .clear-mobile-view-icon { transition: opacity .5s ease .2s; }

#autocomplete {
  right: 0 !important;
  top: 1px;
  width: 0px;
}

#header-search-input {
  background-color: transparent;
  border-style: none;
  color: #fff;
  display: none;
  height: 30px;
  line-height: 1.75rem; /*28px*/
  outline: none;
  padding: 0px;
  padding-right: 50px;
  width: 0px;
}


#header-search.mobile-search-mode #header-search-input {
  display: inline-block;
  width: 100%;
}

#header-search-input::placeholder {
  color: white;
  opacity: 1;
}

#header-search .input-icon {
  background-color: transparent;
  border: none;
  height: 48px;
  padding: 0px 12px 0 12px;
  position: absolute;
  right: 0;
  top: -9px;
}



#header-search .input-icon img{
  height: 24px;
  margin-top: -2px;
  width: 24px;
}


#header-search.mobile-search-mode #autocomplete {
  background-color: $header-color;
  border: 1px solid $search-border-active;
  height: 2rem;
  padding: 0 1rem;
  right: 0;
  width: 0;
}

#header-search.mobile-search-mode.mobile-search-width #autocomplete {
  width: 15rem;
}

#header-search.mobile-search-mode #autocomplete .input-icon img{
  height: 20px;
  width: 20px;
}

#header-search .input-clear {
  right: 45px;
  top: 6px;
}

#autocomplete.focused.with-text .input-clear {
  display: block;
}

#autocomplete.focused .input-icon {
  background-color: $search-border-active; /* $light-blue */
  border-bottom-right-radius: 100px!important;
  border-top-right-radius: 100px!important;
  color:  $search-input-icon-active;
}

#header-search-input::selection {
  color: $dark-blue;
  background: $light-blue;
}

.headerSearchInput {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
}

.headerSearchInput::placeholder {
  font-size: 12px;
}


#header-search .clear-mobile-view-icon {
  display: block;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

#header-search.mobile-search-mode .clear-mobile-view-icon {
  opacity: 1;
  z-index: 0;
}

@media only screen and (min-width: 584px) {

  #header-search.mobile-search-mode.mobile-search-width #autocomplete {
    width: 19rem;
  }

}

@media only screen and (min-width: 776px) {
  #header-search {
    right: 0px;
  }
  #header-search #autocomplete {
    background-color: $header-color;
    border: 1px solid $search-border-inactive;
    height: 2rem;
    padding: 0 1rem;
    right: 0;
    width: 14rem;
  }

  #header-search .input-icon {
  height: 30px;
  top: 0;
}

  #header-search #autocomplete.focused {
    border-color: $search-border-active;
  }

  #header-search-input {
    display: inline-block;
  }
  #header-search #header-search-input {
    display: inline-block;
    width: 100%;
  }

  #autocomplete .input-icon img{
    height: 16px;
    width: 16px;
  }

}

@media only screen and (min-width: 992px) {
  #header-search #autocomplete {
    width: 19rem;
  }

}
</style>

